import { msg } from '@lingui/macro';
import { IconBarcode } from '@tabler/icons-react';
import type { ImporterDescriptor } from '../../../descriptors/types';

const descriptor: ImporterDescriptor = {
  id: 'portfolioProductExternalIdImport',
  status: 'active',
  category: 'product-data',
  popularity: 2,
  icon: IconBarcode,
  title: msg`Update product external IDs`,
  shortTitle: msg`Link products to your ERP`,
  whenToUse: msg`Assign or refresh the unique external IDs that link your products to systems like your ERP or WMS.`,
  outputDescription: msg`Updates the external ID linking each portfolio product to your ERP/WMS.`,
  intents: [
    'Link our SKUs to the ERP',
    'Refresh external IDs',
    'Connect products to a warehouse system',
    'Sync product codes with our backend',
  ],
  keywords: [
    'external ID',
    'ERP',
    'WMS',
    'SKU',
    'code',
    'link',
    'sync',
    'identifier',
    'portfolio',
  ],
  synonyms: ['barcode', 'GTIN', 'EAN', 'SAP', 'NetSuite'],
  inputHints: {
    fileTypes: ['xlsx'],
    sampleHeaders: ['Product short name', 'Product External ID', 'SKU'],
    requiredColumns: ['Product External ID'],
  },
};

export default descriptor;
